<template>
  <div class="search-map">
    <gmap-map ref="gmap"
              :center="center"
              :zoom="12"
              :options="options"
              style="width: 100%; height: 100%;">
      <gmap-marker
        v-for="marker, index in markers"
        :key="index"
        :icon="getMarkerIcon(marker, index)"
        :label="marker.label ? marker.label : null"
        :position="marker.position"
        :clickable="true"
        @mouseover="changeMarker(marker, 'hover')"
        @mouseout="changeMarker(marker, 'out')"
        @click="scrollToProfessional(marker)"/>
    </gmap-map>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import VueScrollTo from 'vue-scrollto'

  export default {
    props: ['filteredProfessionals', 'latitude', 'longitude'],
    data () {
      return {
        options: {
          clickableIcons: false,
          gestureHandling: 'cooperative',
          zoomControlOptions: {position: 3},
          maxZoom: 14,
          scrollwheel: false
        },
        center: {lat: 18.78842372, lng: 98.98594469},
        markers: []
      }
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState',
        hoverProfessionalId: 'booking/getHoverProfessionalId',
        preBookingData: 'booking/getPreBookingData'
      })
    },
    watch: {
      filteredProfessionals () {
        this.displayMarkers()
      }
    },
    methods: {
      getMarkerIcon (marker, index) {
        if (index === 0) {
          return '/static/img/ic-user-home.svg'
        } else {
          return (Number(marker.pid) === Number(this.hoverProfessionalId)) ? '/static/img/circle-location-active.svg' : '/static/img/circle-location.svg'
        }
      },
      changeMarker (marker, action) {
        let url = '/static/img/circle-location.svg'
        let professionalId = null
        if (action === 'hover') {
          url = '/static/img/circle-location-active.svg'
          professionalId = marker.pid
        }
        this.$store.commit('booking/SET_HOVER_PROFESSIONAL_ID', professionalId)
        marker.icon = url
      },
      scrollToProfessional (marker) {
        const options = {
          easing: 'ease-in-out',
          offset: -120,
          cancelable: true,
          x: false,
          y: true
        }
        const targetElement = `#professional-card${marker.pid}`
        VueScrollTo.scrollTo(targetElement, 500, options)
      },
      displayMarkers () {
        this.markers = []
        // User place location marker
        this.markers[0] = {
          position: {lat: this.latitude, lng: this.longitude},
          pid: 0,
          icon: '/static/img/ic-user-home.svg'
        }
        this.center = this.markers[0].position
        let i = 1
        for (let index in this.filteredProfessionals) {
          const num = Number(index) + 1
          const professional = this.filteredProfessionals[index]
          const lat = professional.latitude
          const lng = professional.longitude
          const marker = {
            position: {lat: lat, lng: lng},
            pid: professional.id,
            icon: '/static/img/circle-location.svg',
            label: {color: '#FFFFFF', fontWeight: '400', text: num.toString()}
          }
          if (professional.latitude) {
            this.markers[i] = marker
            i++
          }
        }
      }
    },
    mounted () {
      this.$refs.gmap.$mapPromise.then((map) => {
        const provinceId = this.preBookingData.province_id
        if (provinceId > 0) {
          const lat = this.globalState.citiesLocations[provinceId].lat
          const lng = this.globalState.citiesLocations[provinceId].lng
          this.center = {lat: lat, lng: lng}
        } else {
          this.center = {lat: this.latitude, lng: this.longitude}
        }
        this.displayMarkers()
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/booking/components/ProfessionalMap.vue